const modalityOrder = { male: 0, female: 1 };

export const modalityLabel = (modality) => {
  if (modality === "male") return "Masculino";
  if (modality === "female") return "Femenino";
  return "Sin modalidad oficial";
};

export const rankingSportName = (ranking) => ranking.sport?.name || ranking.sport_name || "Sin deporte";

// The API has historically returned either sport_id or the nested sport object,
// depending on the endpoint. Keep the filter stable in both cases and fall back
// to the name for older records that do not include an id.
export const rankingSportId = (ranking) => String(ranking.sport?.id ?? ranking.sport_id ?? rankingSportName(ranking));

export const rankingCategory = (ranking) =>
  ranking.category || {
    id: ranking.category_id,
    name: ranking.category_name,
    modality: null,
    official_index: null,
    ladder: null,
  };

export const sortClassifications = (rankings) =>
  [...rankings].sort((left, right) => {
    const leftCategory = rankingCategory(left);
    const rightCategory = rankingCategory(right);
    const values = [
      rankingSportName(left).localeCompare(rankingSportName(right), "es"),
      (modalityOrder[leftCategory.modality] ?? 2) - (modalityOrder[rightCategory.modality] ?? 2),
      (leftCategory.ladder?.display_order ?? Number.MAX_SAFE_INTEGER) -
        (rightCategory.ladder?.display_order ?? Number.MAX_SAFE_INTEGER),
      (leftCategory.official_index ?? Number.MAX_SAFE_INTEGER) -
        (rightCategory.official_index ?? Number.MAX_SAFE_INTEGER),
      (left.name || "").localeCompare(right.name || "", "es"),
    ];

    return values.find((value) => value !== 0) || 0;
  });

export const groupClassifications = (rankings) => {
  const groups = new Map();

  sortClassifications(rankings).forEach((ranking) => {
    const category = rankingCategory(ranking);
    const sportName = rankingSportName(ranking);
    const ladder = category.ladder;
    const sportId = rankingSportId(ranking);
    const key = ladder ? `${sportId}:${category.modality}:${ladder.id}` : `${sportId}:${category.modality}:other`;

    if (!groups.has(key)) {
      groups.set(key, {
        key,
        sportName,
        modality: category.modality,
        ladderName: ladder?.name || "Otras categorías",
        official: Boolean(ladder),
        rankings: [],
      });
    }

    groups.get(key).rankings.push(ranking);
  });

  return Array.from(groups.values());
};

// The index presents one sport at a time. Within that sport, show the official
// modalities first and the ladders that belong to each of them afterwards.
export const groupClassificationsByModality = (rankings) => {
  const modalities = new Map();

  groupClassifications(rankings).forEach((ladder) => {
    const key = ladder.modality || "other";

    if (!modalities.has(key)) {
      modalities.set(key, {
        key,
        modality: ladder.modality,
        ladders: [],
        rankingsCount: 0,
      });
    }

    const group = modalities.get(key);
    group.ladders.push(ladder);
    group.rankingsCount += ladder.rankings.length;
  });

  return Array.from(modalities.values()).sort(
    (left, right) => (modalityOrder[left.modality] ?? 2) - (modalityOrder[right.modality] ?? 2),
  );
};
